import {
  Typography,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { MdLightbulbOutline } from 'react-icons/md';
import { StepSubLabel } from '../../../pages/InspecionarProcesso/Acordos/AcordosStyle';
import { ButtonUI, InputField } from '../..';
import useStylesPassoTres from './PassoTres.style';
import MoneyField from '../../UI/Field/Money/MoneyField';
import CheckboxField from '../../UI/Field/Checkbox/CheckboxField';
import NumberInput from '../../UI/Field/Number/NumberInput';
import { getRequiredLabel, toAmericanDate, toBrazilianDate } from '../../../helpers';
import { finalizaPagamentoDiretoService, findDebitarClienteService } from '../../../services/core/pagamentoDireto/pagamentoDireto.service';
import OptionDialogNew from '../../UI/Dialogs/OptionDialog/OptionDialogNew';
import TooltipUI from '../../UI/Tooltip/Tooltip';
import { LightIndicator } from '../../Title/Title.styles';
import DateField from '../../UI/Field/Date/DateField';
import FieldModel, { DATE } from '../../../models/FieldModel';
import { usePagamentoDiretoSelector } from '../../../store/PagamentoDireto/PagamentoDiretoProvider';

export default function PassoTres({
  passoUmControls,
  handlePreviousStep,
  selectedIds,
  handleResetSteps,
}) {
  const stylePassoTres = useStylesPassoTres();
  const [valorPagamento, setValorPagamento] = useState(0);
  const [quitarIntegralmente, setQuitarIntegralmente] = useState(false);
  const [debitarCliente, setDebitarCliente] = useState(false);
  const [comissao, setComissao] = useState(0);
  const [justificativa, setJustificativa] = useState('');
  const [showFinalizarDialog, setShowFinalizarDialog] = useState(false);
  const [openReturnMessageDialog, setOpenReturnMessageDialog] = useState(false);
  const [returnMessage, setReturnMessage] = useState('');
  const [returnCodResult, setReturnCodResult] = useState(0);
  const [dataPagamento, setDataPagamento] = useState(new FieldModel({
    name: 'dataLimiteAcordo',
    value: toBrazilianDate(''),
    type: DATE,
  }));
  const hintDebitarCliente = 'Lembre-se, o cliente pode estar configurado para não debitar a comissão. '
    + 'O sistema sempre vai sugerir o melhor preenchimento desse campo, mas ele pode ser alterado por você conforme a necessidade.';
  const dataAbertura = usePagamentoDiretoSelector(state => state.data.passoUm?.dataAbertura);
  const debitarComissaoPagtoAntesAbertura = usePagamentoDiretoSelector(state => state.data.passoUm?.debitarComissaoPagtoAntesAbertura);
  const [mostrarPopUpAlteracaoDebitarCliente, setMostrarPopUpAlteracaoDebitarCliente] = useState(false);
  const [openDialogAlterarDebitarCliente, setOpenDialogAlterarDebitarCliente] = useState(false);

  const listaDeIds = Object.keys(selectedIds).filter((key => selectedIds[key] === true)).map(key => Number(key));

  const desabilitaFinalizar = !justificativa
  || (!valorPagamento || valorPagamento <= 0)
  || (debitarCliente && (!comissao || comissao <= 0))
  || !dataPagamento.value;

  const handleFinalizar = useCallback(() => {
    finalizaPagamentoDiretoService(listaDeIds, passoUmControls, valorPagamento, quitarIntegralmente, debitarCliente, comissao, justificativa)
      .then((response) => {
        const { data } = response;
        setReturnCodResult(data.codResult);
        if (data.codResult === 0) {
          setReturnMessage('Pagamento Direto realizado com sucesso.');
        } else {
          setReturnMessage(data.msgResult);
        }
        setOpenReturnMessageDialog(true);
      }).catch((e) => {
        toast.error(e.response.data.message);
      });
  }, [listaDeIds, passoUmControls, valorPagamento, quitarIntegralmente, debitarCliente, comissao, justificativa]);

  const atualizarDebitarClientePorDataPagamento = useCallback((value) => {
    if (new Date(`${toAmericanDate(value)} 00:00:00`) < new Date(`${toAmericanDate(dataAbertura)} 00:00:00`)) {
      setDebitarCliente(debitarComissaoPagtoAntesAbertura);
      setMostrarPopUpAlteracaoDebitarCliente(false);
    } else {
      setDebitarCliente(true);
      setMostrarPopUpAlteracaoDebitarCliente(true);
    }
  }, [dataAbertura, debitarComissaoPagtoAntesAbertura]);

  const onChangeDataPagamento = useCallback((e) => {
    const { value } = e.target;
    setDataPagamento(
      new FieldModel(
        {
          ...dataPagamento,
          value,
          error: !value,
          errorMessage: !value ? 'Data do Pagamento é obrigatória.' : '',
        },
      ),
    );
    atualizarDebitarClientePorDataPagamento(value);
  }, [dataPagamento, atualizarDebitarClientePorDataPagamento]);

  useEffect(() => {
    if (passoUmControls?.numProcesso?.value) {
      findDebitarClienteService(passoUmControls.numProcesso.value)
        .then((response) => {
          const { data } = response;
          setComissao(data.comissao);
        }).catch((e) => {
          toast.error(e.response.data.message);
        });
    }
  }, [passoUmControls, setDebitarCliente, setComissao]);

  return (
    <>
      <OptionDialogNew
        open={openDialogAlterarDebitarCliente}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickConfirm={() => {
          setOpenDialogAlterarDebitarCliente(false);
          setDebitarCliente(false);
        }}
        onClickCancel={() => {
          setOpenDialogAlterarDebitarCliente(false);
        }}
      >
        <div style={{
          fontSize: '16px', width: '537px', display: 'flex', textAlign: 'justify',
        }}
        >
          <p>
            A regra é sempre debitar a comissão do Pagamento Direto quando o pagamento é feito após a abertura do processo. Confirma a desmarcação do campo Debitar ao Cliente?
          </p>
        </div>
      </OptionDialogNew>
      <OptionDialogNew
        open={openReturnMessageDialog}
        confirmLabel="OK, ENTENDI"
        onClickConfirm={() => {
          setReturnMessage('');
          setOpenReturnMessageDialog(false);
          if (returnCodResult === 0) {
            handleResetSteps();
          }
        }}
      >
        <div style={{
          fontSize: '16px', width: '537px', display: 'flex', textAlign: 'justify',
        }}
        >
          <p>
            {returnMessage}
          </p>
        </div>
      </OptionDialogNew>
      <OptionDialogNew
        open={showFinalizarDialog}
        confirmLabel="Sim"
        cancelLabel="Não"
        onClickCancel={() => { setShowFinalizarDialog(false); }}
        onClickConfirm={() => {
          handleFinalizar();
          setShowFinalizarDialog(false);
        }}
      >
        <div style={{
          fontSize: '16px', width: '537px', display: 'flex', textAlign: 'justify',
        }}
        >
          <p>
            Esta operação de Pagamento Direto não poderá ser desfeita.
            <br />
            Tem certeza que deseja realmente continuar?
          </p>
        </div>
      </OptionDialogNew>
      <StepSubLabel>
        <Typography>Informe o valor do Pagamento Direto e o valor de Comissionamento, se devido:</Typography>
      </StepSubLabel>
      <div style={{ width: '184px', marginTop: '10px' }}>
        <MoneyField
          isForm
          name="valorPagamento"
          value={valorPagamento}
          label={getRequiredLabel('Valor do Pagamento', true)}
          onChange={(e) => { setValorPagamento(e.target.value); }}
        />
      </div>
      <div style={{ width: '282px', marginTop: '10px', marginLeft: '8px' }}>
        <CheckboxField
          label="Quitar integralmente os Títulos selecionados"
          name="quitarIntegralmente"
          checked={quitarIntegralmente}
          onChange={(e) => { setQuitarIntegralmente(e.target.checked); }}
        />
      </div>
      <div style={{
        width: '180px', marginTop: '10px', display: 'flex',
      }}
      >
        <div>
          <DateField
            isForm
            fullWidth
            label={getRequiredLabel('Data do Pagamento', true)}
            error={dataPagamento.error}
            name={dataPagamento.name}
            value={dataPagamento.value}
            errorMessage={dataPagamento.errorMessage}
            onChange={onChangeDataPagamento}
          />
        </div>
        <div>
          <TooltipUI style={{ marginTop: '10px', marginLeft: '8px' }} title="Informar a data em que o Devedor realizou o pagamento para o Cliente">
            <LightIndicator><MdLightbulbOutline /></LightIndicator>
          </TooltipUI>
        </div>
      </div>
      <div style={{
        width: '160px', marginTop: '10px', marginLeft: '8px', display: 'flex',
      }}
      >
        <div>
          <CheckboxField
            label="Debitar ao Cliente"
            name="debitarCliente"
            checked={debitarCliente}
            onChange={(e) => {
              if (!e.target.checked) {
                setComissao(comissao);
                if (mostrarPopUpAlteracaoDebitarCliente) {
                  setOpenDialogAlterarDebitarCliente(true);
                } else {
                  setDebitarCliente(e.target.checked);
                }
              } else {
                setDebitarCliente(e.target.checked);
              }
            }}
          />
        </div>
        <div>
          <TooltipUI style={{ marginLeft: '8px' }} title={hintDebitarCliente}>
            <LightIndicator><MdLightbulbOutline /></LightIndicator>
          </TooltipUI>
        </div>
      </div>
      {debitarCliente && (
        <div style={{ width: '126px', marginTop: '10px' }}>
          <NumberInput
            numberType="percentage"
            acceptEmptyValue
            maxValue={100}
            fullWidth
            isForm
            label={getRequiredLabel('Comissão', true)}
            sideText="(%)"
            value={comissao}
            name="comissao"
            onChange={(e) => { setComissao(e.target.value); }}
          />
        </div>

      )}

      <div style={{ width: '439px', marginTop: '10px' }}>
        <InputField
          fullWidth
          isForm
          label="Justificativa*:"
          value={justificativa}
          name="justificativa"
          onChange={(e) => { setJustificativa(e.target.value); }}
        />
      </div>

      <div className={stylePassoTres.div__AlignButton}>
        <div className={stylePassoTres.div__Button}>
          <ButtonUI
            color="white"
            onClick={handlePreviousStep}
          >
            Voltar
          </ButtonUI>
        </div>
        <div className={stylePassoTres.div__ButtonFinalizar}>
          <ButtonUI
            onClick={() => { setShowFinalizarDialog(true); }}
            color="custom"
            customColor="#43A047"
            disabled={desabilitaFinalizar}
          >
            Finalizar
          </ButtonUI>
        </div>
      </div>
    </>
  );
}
